import {Component, Inject, OnInit, NgModule} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-item',
  standalone: true,
  imports:[
    FormsModule,
    MatRadioModule,
    CommonModule,
    MatDialogModule
  ],
  providers: [
  ],
  templateUrl: './alertsModal.component.html',
  styleUrls: ['./alertsModal.component.css']
})
export class AlertsModalComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<AlertsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
 }

  ngOnInit(): void {
    console.log(this.data);
  }
  
  continue(){
    this.dialog.close(); //return result to the dialog opener.
  }
}
